<div class="edit-booking">
    <div class="title-container">
        <h2>{{ 'edit_booking.title' | translate }}</h2>
    </div>

    <div class="sub-title-container">
        <p>{{ 'edit_booking.sub_title' | translate }}</p>
    </div>
    <div class="edit-btn-container" [matTooltip]="!isEditable? 'Nessuna data disponibile' : ''"
        matTooltipPosition="below">
        <button [disabled]="!isEditable" class="my-button" (click)="goTo('edit')">{{ 'edit_booking.change_book' | translate }}</button>
    </div>

    <div class="sub-title-container">
        <p>{{ 'edit_booking.remove_book' | translate }}</p>
    </div>
    <div class="edit-btn-container">
        <button class="my-button" (click)="showConfirmDelete()">{{ 'edit_booking.delete_book' | translate }}</button>
    </div>
</div>